import Phaser from 'phaser';
import gameScene from './Scenes/GameScene';
import Preloader from './Scenes/Preloader';
import menuScene from './Scenes/MenuScene';

class Game extends Phaser.Game {
  constructor() {
    super({
      type: Phaser.AUTO,
      width: 512,
      height: 256,
      physics: {
        default: 'arcade',
        arcade: {
          gravity: { y: 0 },
          debug: false,
        },
      },
      scale: {
        zoom: 2,
      },
      scene: [Preloader, menuScene, gameScene],
    });

    // this.scene.run('preloadScene');
  }
}

export default new Game();
